import orderApi from '@/api/order'

const state = {
  exchanges: [],
  loading: false,
  loaded: false,
}

const getters = {}

const actions = {
  async fetchLog({ commit }, id) {
    commit('SET_LOADING')
    try {
      const { data } = await orderApi.getIntegrationLog(id)
      commit('SET_LOG', data)
    } catch {
      commit('SET_LOG', [])
    }
  },
}

const mutations = {
  SET_LOADING(state) {
    state.loading = true
  },
  SET_LOG(state, data) {
    state.exchanges = data || []
    state.loading = false
    state.loaded = true
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
